<template>
  <v-row class="title-wrap">
    <v-col cols="12" class="icon-title"
      ><icon-work-day :width="22" :height="22" />{{
        '휴일 근무일자를 선택'
      }}</v-col
    >
    <v-col cols="12" class="text-center calendar-title">날짜선택</v-col>
  </v-row>

</template>
<script>
import IconWorkDay from '@/assets/customIcon/IconWorkDay.vue';
import { mapGetters } from 'vuex';
import applCdMixin from '@/mixins/applCdMixin.js';

export default {
  mixins: [applCdMixin],
  computed: {
    ...mapGetters('ELA', ['GET_REST_CNT', 'GET_GNT_CD']),
  },
  components: {
    IconWorkDay,
  },
};
</script>

<style>
/* 날짜 선택 하단 패딩 */
.title-desc {
  padding-bottom: 20px;
}
/* 배우자 출산 휴가 시 label */
.sub-label {
  margin-top: 22px;
  margin-bottom: 8px;
}
.sub-label .label-title {
  margin-bottom: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #505961;
}
.sub-label .label-date {
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: -0.48px;
  color: #3cb149;
}
</style>
